var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('HeaderNav'),_c('HeroSection',{staticClass:"section-spacing"}),_c('AboutSection',{staticClass:"section-spacing"}),_c('FooterInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }